import styled, { keyframes } from 'styled-components'
import { Tokens } from '@tmov/design-system/theme/types'

const { colors } = Tokens.eixods

export type Props = {
  width: string
  maxWidth?: string
  height: string
  maxHeight?: string
}

const animationLoading = keyframes`
  to {
    background-position: 100% 0, 0 0;
  }
`

export const Shape = styled.div<Props>`
  display: block;
  border-radius: 4px;
  width: ${props => `${props.width}`};
  max-width: ${props => `${props.maxWidth}`};
  height: ${props => `${props.height}`};
  animation: ${animationLoading} 1.2s linear infinite;
  background: ${colors.neutral.grey[0]};
  background: linear-gradient(
      to right,
      rgba(241, 244, 245, 0),
      rgba(241, 244, 245, 0.5) 50%,
      rgba(241, 244, 245, 0) 80%
    ),
    ${colors.neutral.grey[10]};
  background-repeat: repeat-y;
  background-size: 50px 200px;
  background-position: 0 0;
`
